var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuItem, TextField } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useController } from 'react-hook-form';
import { fetchEstados } from '../../services/localidades.service';
var EstadoSelect = function (_a) {
    var name = _a.name, control = _a.control, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.required, required = _c === void 0 ? false : _c;
    var _d = useQuery({
        queryKey: ['estados'],
        queryFn: fetchEstados,
    }), estados = _d.data, isLoading = _d.isLoading;
    var _e = useController({
        name: name,
        control: control,
    }), field = _e.field, error = _e.fieldState.error;
    return (_jsxs(TextField, __assign({}, field, { "data-testid": name, select: true, label: "UF", variant: "outlined", fullWidth: true, margin: "normal", required: !disabled && required, error: !!error, helperText: error ? error.message : '', disabled: disabled || isLoading, children: [_jsx(MenuItem, { value: 0, children: "Selecione o estado" }), estados === null || estados === void 0 ? void 0 : estados.map(function (estado) { return (_jsxs(MenuItem, { value: estado.sigla, children: [estado.sigla, " - ", estado.nome] }, estado.sigla)); })] })));
};
export default EstadoSelect;
